import '../../../../resources/js/bootstrap.js';
import GlobalSearch                                                  from "./class/widgets/GlobalSearch";
import AuthHeader                                                    from "./class/widgets/AuthHeader";
import Footer                                                        from "./class/widgets/Footer";
import {BRTabs, BRCarouselStatic, BRDropdown}                        from "@dbetts/brjstools";
import RelatedProducts                                               from "./class/widgets/RelatedProducts";
import ProductActions                                                from "./class/mixin/ProductAction";

window.addEventListener('load', function() {

    new GlobalSearch();
    new AuthHeader();
    new Footer();
    BRDropdown.initAll();
    BRTabs.initAll();
    BRCarouselStatic.initAll();
    RelatedProducts.initAll(); // ProductActions.setAllProductListeners(); is set in RelatedProducts.
    ProductActions.validateQtyChange();

    const category = [];
    document.querySelectorAll('[data-breadcrumbs] li').forEach((li) => {
        if (li.innerText !== '/') {
            category.push(li.innerText);
        }
    });
    const productContainer = document.querySelector('section.product.container').children[0].children[1];

    _paq.push(['setEcommerceView',
               productContainer.querySelector('[data-prod-id]').getAttribute('data-prod-id'),
               productContainer.children[0].innerText,
               category,
               parseFloat(productContainer.children[1].innerText),
              ]);
    _paq.push(['trackPageView']);
});